export default "__VITE_ASSET__DkwJAUNm__"